module.exports = __webpack_public_path__ + "img/49.7.Chla.9ac18af9.png";